<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">参数设置</div>
      <el-form-item label="是否开启万里牛发货" prop="is_open">
        <el-switch v-model="form.is_open">
        </el-switch>
      </el-form-item>
      <el-form-item label="店铺昵称">
        <el-input v-model="form.shop_nick" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppKey">
        <el-input v-model="form.app_key" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret">
        <el-input v-model="form.app_secret" class="max-w460"></el-input>
      </el-form-item>
      

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          is_open: '',
          shop_nick: '',
          app_key: '',
          app_secret: '',
        },
        loading: false,
      };
    },
    created() {
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        SettingApi.wanliniuSetting({}, true)
          .then(data => {
            self.form = data.data.setting;
          })
          .catch(error => {});

      },
      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.saveWanliniuSetting(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },



    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/wanliniu/index.vue